import { render, staticRenderFns } from "./FullCoverImage.vue?vue&type=template&id=3b99e21b&"
import script from "./FullCoverImage.vue?vue&type=script&lang=js&"
export * from "./FullCoverImage.vue?vue&type=script&lang=js&"
import style0 from "./FullCoverImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports